// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1OJui","head":"ProcedureTableInfo_head__1O1Ka"};